import { matchPath } from 'react-router-dom';

import {
  SPAN_PAYMENT_LINK_SIGNATURE_PARAM,
  SPAN_PAYMENT_LINK_SIGNATURE_STORAGE_KEY_PREFIX,
} from '@features/reservation/constants/spanPaymentLink';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

/**
 * Lift the signature of the payment link out of the address bar before anything reads the URL — the router, Sentry,
 * Google Analytics, the referrer of the next request. It is kept for the tab, so a reload still pays the same span.
 */
export const captureSpanPaymentLinkSignatureFromUrl = (): void => {
  const match = matchPath(ROUTE_PATHS[RouteName.RESERVATION_SPAN_PAYMENT_LINK], window.location.pathname);
  const reservationSpanId = match?.params.reservationSpanId;
  if (!reservationSpanId) return;

  const url = new URL(window.location.href);
  const signature = url.searchParams.get(SPAN_PAYMENT_LINK_SIGNATURE_PARAM);
  if (signature === null) return;

  sessionStorage.setItem(`${SPAN_PAYMENT_LINK_SIGNATURE_STORAGE_KEY_PREFIX}${reservationSpanId}`, signature);
  url.searchParams.delete(SPAN_PAYMENT_LINK_SIGNATURE_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

/** The signature of the payment link of the span, as captured for this tab; empty when there is none. */
export const readSpanPaymentLinkSignature = (reservationSpanId: string): string =>
  sessionStorage.getItem(`${SPAN_PAYMENT_LINK_SIGNATURE_STORAGE_KEY_PREFIX}${reservationSpanId}`) ?? '';
